import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <div className='row bg-dark '>
        <p className='lead text-center py-2 m-0'>© 2022 Developer </p>
    </div>
  )
}
